module.exports = __webpack_public_path__ + "static/foamie-logo-018bd7cdb2103e71282790aee685cae7.png";